<template>
  <div class="tabs_content_left_inner">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'sidebar-item'
}
</script>
